import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getClients } from "../api";
import { DocListTab, SalesDocPage } from "./SalesDocShared";

export default function QuotationsPage() {
  const { data: clients = [] } = useQuery({ queryKey: ["clients"], queryFn: getClients });

  return (
    <SalesDocPage
      title="Quotations"
      subtitle="Convert to Billing Note or Tax Invoice"
      typeColor="#7e22ce"
    >
      <DocListTab
        docType="quotation"
        clients={clients}
        canApprove
        convertOptions={[
          { label: "Billing Note", target: "billing_note", color: "#1d4ed8" },
          { label: "Tax Invoice",  target: "tax_invoice",  color: "#c2410c" },
        ]}
      />
    </SalesDocPage>
  );
}
